module.exports = __webpack_public_path__ + "img/17-2.a06db5e0.png";